export function normalizeOpenLibraryId(id: string): string {
  if (!id) return '';
  // Remove '/works/' prefix if present, return just the ID
  return id.replace(/^\/works\//, '');
}

export function isUuid(id: string): boolean {
  if (!id) return false;
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(id);
}
